interface FeatureHighlightProps {
  onCtaClick: () => void;
}

export default function FeatureHighlight({ onCtaClick }: FeatureHighlightProps) {
  return (
    <section className="bg-[#050D18] overflow-hidden">
      {/* Full-bleed visual banner */}
      <div className="relative h-[70vh] min-h-[520px] overflow-hidden">
        <img
          src="https://public.readdy.ai/ai/img_res/11d9c9291764b2c3749f71bad9bf1ba1.jpg"
          alt="Henexa AI system visualization"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#050D18]/90 via-[#050D18]/40 to-transparent" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#050D18] via-transparent to-transparent" />

        {/* Overlay text */}
        <div className="absolute inset-0 flex items-center">
          <div className="max-w-7xl mx-auto px-8 lg:px-16 w-full">
            <div className="max-w-xl">
              <span className="text-xs tracking-widest uppercase text-[#5EEAD4]/80 font-medium block mb-6">
                The System
              </span>
              <h2 className="text-5xl lg:text-7xl font-semibold text-white leading-[1.0] tracking-[-0.025em] mb-6">
                Every lead.<br />Every channel.<br />Zero gaps.
              </h2>
              <p className="text-base text-white/50 leading-relaxed tracking-wide max-w-sm">
                One unified system that captures and moves every prospect
                forward—without manual intervention.
              </p>
              <button
                onClick={onCtaClick}
                className="mt-8 inline-flex items-center gap-2 text-sm text-white/70 hover:text-white tracking-wide transition-colors cursor-pointer group"
              >
                <span>Start building</span>
                <div className="w-4 h-4 flex items-center justify-center group-hover:translate-x-1 transition-transform">
                  <i className="ri-arrow-right-line" />
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
